import { render, staticRenderFns } from "./RecordSegmenti.vue?vue&type=template&id=9081258a"
import script from "./RecordSegmenti.vue?vue&type=script&lang=js"
export * from "./RecordSegmenti.vue?vue&type=script&lang=js"
import style0 from "./RecordSegmenti.vue?vue&type=style&index=0&id=9081258a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports